<template>
    <el-select v-model="value[name]" filterable clearable placeholder="请选择" :disabled="disabled" @change="getTypeVal">
        <el-option
                v-for="(item,index) in list"
                :key="index"
                :label="item.rate"
                :value="item.rate">
            {{item.rate}}%
        </el-option>
    </el-select>
</template>

<script>
    export default {
        data() {
            return {
                list: [],
            }
        },
        props: {
            code: {default: ""},
            name: {default: ""},
            value: null,
            disabled: {default: false}
        },
        methods: {
            findList() {
                this.axiosPost("/joinInvoice/findList.do", {}, function (resData) {
                    this.list = resData.list;
                });
            },
            getTypeVal(val) {
                this.$emit("change", val);
            }
        },
        mounted() {
            this.findList();
        },
        watch: {}
    }
</script>



// WEBPACK FOOTER //
// src/kc/keTemp/sysRate.vue